<template>
  <div class="w-full explore-showcase" id="PopularItineraries">
    <div class="mx-auto py-24 max-w-7xl md:py-28">
      <div class="mx-auto max-w-5xl text-center px-8">
        <p
          class="
            hidden
            md:block md:text-2xl md:leading-tight
            font-medium
            text-ternGray
            mb-4
          "
        >
          {{ header }}
        </p>
        <p class="text-3xl md:text-6xl leading-tight font-bold">
          {{ mainHeader }}
        </p>
        <p class="text-sm text-ternGray font-medium pt-4 px-8 md:hidden">
          {{ subheader }}
        </p>
      </div>

      <!-- Trips Grid -->
      <div
        class="
          grid grid-cols-1
          md:grid-cols-3
          gap-8
          mt-8
          md:mt-20
          px-12
          md:px-8
        "
      >
        <div
          v-for="(trip, idx) in featuredTrips"
          :key="idx"
          @click="openTrip(trip.link)"
          class="
            group
            cursor-pointer
            overflow-hidden
            rounded-2xl
            bg-white
            shadow-md
            transform
            transition-all
            duration-500
            ease-out
            hover:-translate-y-3 hover:shadow-2xl hover:rotate-1
          "
        >
          <div class="relative">
            <!-- Image with scale & brightness boost on hover -->
            <img
              :src="trip.image"
              alt="Trip preview"
              class="
                object-cover
                w-full
                rounded-t-2xl
                transition
                duration-500
                ease-out
                group-hover:scale-110 group-hover:brightness-110
              "
            />

            <div
              class="
                absolute
                inset-x-0
                bottom-0
                p-3
                bg-gradient-to-t
                from-black
                to-transparent
                backdrop-blur-md
              "
            >
              <!-- Apple-style light frosted footer -->
              <div class="h-32 px-4 py-3 flex flex-col justify-end">
                <h5 class="text-white text-lg font-bold">
                  {{ trip.name }}
                </h5>
                <p class="mt-1 text-white text-sm">
                  {{ trip.subtitle }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CTA -->
      <div class="flex justify-center mt-8">
        <Button class="mt-12 sm:mt-16 w-3/5 md:w-2/5 lg:w-1/5" />
      </div>
    </div>
  </div>
</template>

<script>
import Button from './Buttons/TernButtonExplore.vue';
import emilyInParis from '@/assets/popular_itineraries/emily_in_paris.jpg';
import sanFrancisco from '@/assets/popular_itineraries/san_francisco.png';
import tokyo from '@/assets/popular_itineraries/tokyo.jpg';

export default {
  name: 'PopularItineraries',
  components: {
    Button,
  },
  data() {
    return {
      header: 'Explore popular itineraries',
      mainHeader: 'Start planning with real recommendations',
      subheader:
        'See what others have built using Tilly — then make it your own.',
      featuredTrips: [
        {
          name: 'Tilly’s SF Recs',
          subtitle: 'San Francisco, USA 🇺🇸',
          image: sanFrancisco,
          link: 'https://app.heytilly.ai/tern/3r89RkyBItIyv8v8j7nd',
          imageLoaded: false,
        },
        {
          name: 'Emily in Paris (Season 3)',
          subtitle: 'Paris, France 🇫🇷',
          image: emilyInParis,
          link: 'https://app.heytilly.ai/trip/n5BuRGPG4P81Fp5WCqRb',
          imageLoaded: false,
        },
        {
          name: 'NY Times 36 hrs in Tokyo',
          subtitle: 'Tokyo, Japan 🇯🇵',
          image: tokyo,
          link: 'https://app.heytilly.ai/tern/nDTQyLt0Zp5NyKffwBRQ',
          imageLoaded: false,
        },
      ],
    };
  },
  methods: {
    openTrip(link) {
      window.open(link, '_blank');
    },
  },
};
</script>
